import {createFileRoute} from '@tanstack/react-router';
import {CustomCursor} from '@features/ui/components/CustomCursor';
import ChatShell from '@features/flow/[id]/page';

export const Route = createFileRoute('/flow/$id')({
  component: function FlowPage() {
    const {id} = Route.useParams();
    return (
      <div className='h-full'>
        <CustomCursor />
        <div className='bg-canvas-background'>
          <ChatShell id={id} />
          <title>Banani | Flow</title>
        </div>
      </div>
    );
  },
});
